import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ThemeContext from '../../contexts/ThemeContext';

import './ThemedSlider.scss';

class ThemedSlider extends Component {
	static contextType = ThemeContext;

	state = {
		value: this.props.value
	};

	onChange = (e) => {
		let value = parseInt(e.target.value);
		this.setState({
			value
		});
		this.props.onChange(value)
	};

	render(){
		return (
			<div className="themedSliderContainer">
				<div className="themeSliderIndicatorWrapper">
					<span className="themeSliderIndicator themeSliderIndicator--min">{this.props.min}</span>
					<span className="themeSliderIndicator themeSliderIndicator--value">{this.state.value}</span>
					<span className="themeSliderIndicator themeSliderIndicator--max">{this.props.max}</span>
				</div>
				<input
					{...this.props}
					type="range"
					onChange={this.onChange}
					value={this.state.value}
					className={`${this.props.className || ''} themedSlider ${this.context.isDarkTheme ? 'themedSlider--dark' : ''}`}
				>
				</input>

			</div>
		)
	}
}

ThemedSlider.propTypes = {
	value: 			PropTypes.number.isRequired,
	min: 			PropTypes.number.isRequired,
	max: 			PropTypes.number.isRequired,
	onChange:		PropTypes.func.isRequired
};

export default ThemedSlider;